import * as React from "react";
const SvgFiRrUserChef = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-chef_svg__a)">
      <path
        fill="#062147"
        d="M20.07 23.99a1 1 0 0 1-1.132-.848C18.518 20.21 15.966 18 13 18h-2v5a1 1 0 1 1-2 0v-4.653c-2.05.732-3.62 2.552-3.94 4.795a1 1 0 1 1-1.979-.283c.56-3.91 3.965-6.858 7.92-6.858h2c3.955 0 7.359 2.948 7.919 6.858a1 1 0 0 1-.85 1.132zM4 3c0-1.654 1.346-3 3-3 .64 0 1.407.206 2.095.553C9.714.333 10.842 0 12 0s2.286.333 2.904.553C15.592.206 16.359 0 17 0c1.654 0 3 1.346 3 3 0 1.294-.772 2.438-2 2.848v3.153a6 6 0 1 1-12 0V5.855a3.035 3.035 0 0 1-2.001-2.854zm12 5H8v1c0 1.125.478 2.203 1.31 2.961a3.98 3.98 0 0 0 3.086 1.021C14.416 12.789 16 10.946 16 8.786zM6 3c0 .432.275.813.684.949.788.262 1.318 1.027 1.317 1.905V6h7.998v-.146c0-.878.53-1.644 1.318-1.904A1 1 0 0 0 17 2.001c-.345 0-.963.172-1.48.5a1 1 0 0 1-.938.071c-.014-.006-1.321-.571-2.582-.571s-2.57.565-2.582.571a1 1 0 0 1-.94-.071c-.515-.328-1.134-.5-1.478-.5A1 1 0 0 0 6 3m8.5 17a1.5 1.5 0 1 0 0 3.001 1.5 1.5 0 0 0 0-3.001"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-chef_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserChef;
